<template lang="pug">
div
  trumbowyg#editor(
    :value="value",
    :config="config",
    placeholder="Digite o texto...",
    class="form-control",
    name="content",
    @tbw-change="textChange",
    @tbw-blur="textBlur"
  )
</template>

<script>
import Trumbowyg from 'vue-trumbowyg'
import Helper from '../utils/helper'

import 'trumbowyg/dist/ui/trumbowyg.css' // eslint-disable-line
import 'trumbowyg/dist/langs/pt_br' // eslint-disable-line

export default {
  components: {
    Trumbowyg
  },

  props: {
    textEditable: {
      default: false
    },
    value: {
      required: true
    }
  },

  data () {
    return {
      config: {
        lang: 'pt_br',
        content: this.value,
        tagsToRemove: ['script', 'link'],
        removeformatPasted: true,
        btns: [
          ['strong', 'italic', 'underline', 'strikethrough'],
          ['removeformat'],
          ['formatting'],
          ['unorderedList', 'orderedList'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['undo', 'redo']
        ]
      }
    }
  },

  mounted () {
    this.config.texteditable = this.textEditable
  },

  methods: {
    /* eslint-disable */
    textChange () {
      this.$emit('input', $('#editor').trumbowyg('html'))
    },

    textBlur () {
      if (Helper.cleanHtmlCssWhiteSpaceFromString($('#editor').trumbowyg('html')).length > 0) {
        this.$emit('blur', $('#editor').trumbowyg('html'))
      } else {
        $('#editor').trumbowyg('html', '');
        this.$emit('blur', $('#editor').trumbowyg('html'))
      }
    }
  }
};
</script>

<style lang="scss">
  .trumbowyg-box, .trumbowyg-editor {
    margin: 0 !important;
    border-radius: 5px;
  }

  .trumbowyg-editor {
    padding: 10;
  }

  .trumbowyg-button-pane {
    background: white !important;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    z-index: 1 !important;
  }

  .trumbowyg-button-pane {
    button:hover, button:focus, button.trumbowyg-active {
      svg {
        fill: #279d63;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppTextEditor.vue